import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { ReactNode } from "react";

import { Radius, Spacing } from "Infrastructure/Themes/Themes";

interface ProjectTypeTileProps {
  icon: ReactNode;
  iconColor: string;
  label: string;
  onClick?: () => void;
}

export const ProjectTypeTile = ({
  icon,
  iconColor,
  label,
  onClick,
}: ProjectTypeTileProps): React.ReactNode => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        height: "52px",
        borderRadius: Radius.M,
        backgroundColor: theme.colors.backgroundTile,
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(Spacing.S, Spacing.M),
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: theme.colors.backgroundInput,
        },
      }}
    >
      <Stack
        direction="row"
        spacing={Spacing.M}
        alignItems="center"
        sx={{ width: "100%" }}
      >
        <Box
          sx={{
            color: iconColor,
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
              width: "24px",
              height: "24px",
            },
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.palette.common.white,
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>
      </Stack>
    </Box>
  );
};
